import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getPackingModeList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/packing-mode/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};
const getPackingModeArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/packing-mode/archive-list/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};
const getPackingModeById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/packing-mode/${id}`, {
    headers: authHeader(),
  });
};

const addPackingMode = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/packing-mode/`,
    formData,
    { headers: authHeader() }
  );
};

const editPackingMode = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/packing-mode/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};

const deletePackingMode = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/packing-mode/${id}/`,
    { headers: authHeader() }, // Authentication header
  );
};
const unArchivePackingRecord = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/packing-mode/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() }, // Authentication header
  );
};

const packingService = {
  getPackingModeList,
  getPackingModeArchiveList,
  getPackingModeById,
  addPackingMode,
  editPackingMode,
  deletePackingMode,
  unArchivePackingRecord,
};
export default packingService;


